export class QUERY_NAMES {
    static readonly PRACTICE_FRONT_BY_DOMAIN = 'practice_fronts_by-id';
}
